import React from "react";

const bannerStyle = {
  width: "100%",
  background: "#ff9800",
  color: "#fff",
  textAlign: "center",
  padding: "8px 0",
  position: "fixed",
  top: 0,
  left: 0,
  zIndex: 1000,
  fontWeight: "bold",
};

export default function OfflineBanner() {
  return (
    <div style={bannerStyle} role="status" aria-live="polite">
      You are offline. Some features may be unavailable.
    </div>
  );
}
